import { InfoTicketSkeleton } from 'entities/ticket/ui/info-ticket'

import { Skeleton as SkeletonLib } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const SkeletonTariff = () => {
  return (
    <div className={s.container}>
      <div className={s.header}>
        <SkeletonLib
          width={170}
          height={28}
          borderRadius={12}
        />
        <SkeletonLib
          width={250}
          height={18}
          borderRadius={12}
        />
      </div>
      <div className={s.list}>
        {new Array(3).fill(null).map((_, index) => (
          <InfoTicketSkeleton key={index} />
        ))}
      </div>

      <SkeletonLib
        height={56}
        containerClassName={s.button}
      />
    </div>
  )
}
